// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2oGNj","title":"BackImages_title__1DwgN","images":"BackImages_images__2P_WV"};